//import 'bootstrap/dist/css/bootstrap.min.css';
//import 'bootstrap/scss/bootstrap.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.scss';
import reportWebVitals from './reportWebVitals';

const render = ({ container, config }: { container: string; config: any }) => {
    ReactDOM.render(
        <React.StrictMode>
            <div className="custom-area-reporter">
                <App config={config} />
            </div>
        </React.StrictMode>,
        document.getElementById(container)
    );
};

/*
Start app from JavaScript.
<script>
  window.customAreaReporter.launch({
    container: 'root',
    appid: '1a451d1bbe3544849585ab2745c25f5d',
    ... any config options you wish to override ...
    fontFamily: 'Avenir Next',
    fontSize: 16,
    etc.
  });
</script>
*/
declare global {
    var __webpack_public_path__: any;
    interface Window {
        customAreaReporter: any;
    }
}
window.customAreaReporter = ((car: any) => {
    const activeScript =
            document.querySelector(
                'script[src*="/custom-area-reporter/static/js"]'
            ) || document.currentScript,
        hostPath =
            activeScript !== undefined && activeScript !== null
                ? activeScript.getAttribute('src')
                : null;
    car.launch = ({
        container,
        appid = '',
        ...rest
    }: {
        container: string;
        appid?: string;
        [key: string]: any;
    }) => {
        let derivedHost =
            rest.host !== undefined
                ? rest.host
                : hostPath !== undefined &&
                  hostPath !== null &&
                  hostPath.indexOf('/custom-area-reporter/static/js') > 0
                ? hostPath.substring(0, hostPath.indexOf('/static/js'))
                : '';
        // See https://webpack.js.org/guides/public-path/#on-the-fly
        if (derivedHost !== '')
            __webpack_public_path__ = `${derivedHost.replace(
                /^(.*)\/$/,
                '$1'
            )}/`;
        render({
            container,
            config: {
                appid:
                    process.env.NODE_ENV === 'development' &&
                    (appid === '' || appid === null)
                        ? 'ef552ef555c4460494bb2d5a7838b645'
                        : appid ?? '',
                host: derivedHost,
                ...rest
            }
        });
    };
    return car;
})(window.customAreaReporter || {});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
